import React from "react";
import styles from "./attachment-preview-section.module.css";
import { CloseCircleOutlined } from "@ant-design/icons";

const AttachmentPreviewSection = ({ attachments, removeAttachment }) => {
  return (
    <div className={styles["chat-attachment-preview"]}>
      {attachments?.some((file) => file?.type.startsWith("image/")) && (
        <div className={styles["chat-attachment-row"]}>
          {attachments
            ?.filter((file) => file?.type.startsWith("image/"))
            ?.map((file, index) => (
              <div className={styles["chat-attachment-wrapper"]} key={index}>
                <div className={`${styles["chat-attachment-item"]} ${styles["image-item"]}`}>
                  <img
                    src={file?.preview}
                    alt="preview"
                    className={styles["chat-attachment-img-preview"]}
                  />
                  <CloseCircleOutlined
                    className={styles["remove-attachment"]}
                    onClick={() => removeAttachment(file)}
                  />
                </div>
              </div>
            ))}
        </div>
      )}

      {attachments?.some((file) => !file?.type.startsWith("image/")) && (
        <div className={styles["chat-attachment-row"]}>
          {attachments
            ?.filter((file) => !file?.type.startsWith("image/"))
            ?.map((file, index) => (
              <div className={styles["chat-attachment-wrapper"]} key={index}>
                <div className={`${styles["chat-attachment-item"]} ${styles["file-item"]}`}>
                  <span>{file?.name}</span>
                  <CloseCircleOutlined
                    className={styles["remove-attachment"]}
                    onClick={() => removeAttachment(file)}
                  />
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default AttachmentPreviewSection;